import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-check-out-breadcrumb-card',
  templateUrl: './mcommerce-virtual-cash-register-check-out-breadcrumb-card.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-check-out-breadcrumb-card.component.scss']
})
export class McommerceVirtualCashRegisterCheckOutBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
